import React, { FC } from "react";

import { InfoOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  OutlinedTextFieldProps,
  TextField,
} from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";

interface IgTextfieldHeaderWTooltipProps extends OutlinedTextFieldProps {
  title?: string;
  tooltip?: string;
  titleFontSize?: string;
}

/**
 * @see TextField
 * @see Grid
 */
export const IgTextfieldHeaderWTooltip: FC<IgTextfieldHeaderWTooltipProps> = (
  props
) => {
  const { title, children, tooltip, titleFontSize, ...rest } = props;
  return (
    <Grid item container direction={"column"} rowSpacing={0.5}>
      <Grid item container direction={"row"} alignItems={"center"}>
        <Grid item>
          <IgTypography
            sx={{ fontWeight: 600, fontSize: titleFontSize || "14px" }}
          >
            {title}
          </IgTypography>
        </Grid>
        <Grid item>
          {tooltip ? (
            <IgTooltip title={<p>{tooltip}</p>}>
              <IconButton size={"small"} aria-label="info">
                <InfoOutlined fontSize={"small"} />
              </IconButton>
            </IgTooltip>
          ) : (
            <Box sx={{ width: "0px", height: "30px" }} />
          )}
        </Grid>
      </Grid>
      <Grid item>
        <TextField sx={{ width: "100%" }} {...rest}>
          {children}
        </TextField>
      </Grid>
    </Grid>
  );
};
